import { HERO_BG, LOGO_URL } from "@/lib/nav";
import { Crosshair, Brain, ShieldCheck } from "lucide-react";

export function AuthLayout({ children, title, subtitle }) {
    return (
        <div className="min-h-screen flex bg-obsidian">
            <div className="hidden lg:flex flex-col justify-between w-[46%] relative overflow-hidden border-r border-border">
                <div className="absolute inset-0">
                    <img src={HERO_BG} alt="" className="w-full h-full object-cover opacity-40" />
                    <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/60 to-transparent" />
                    <div className="absolute inset-0 ww-grid-bg opacity-60" />
                </div>
                <div className="relative z-10 p-10">
                    <img src={LOGO_URL} alt="WhiteWater AI" className="w-48 object-contain drop-shadow-2xl" />
                </div>
                <div className="relative z-10 p-10">
                    <h2 className="font-heading text-4xl font-black tracking-tighter leading-tight max-w-md">
                        Finish your session.<br /><span className="text-volt">Get coached</span> instantly.
                    </h2>
                    <p className="mt-4 text-sm text-muted-foreground max-w-md">
                        Automatic clips, AI match analysis, improvement tracking and highlight generation — without reviewing hours of footage.
                    </p>
                    <div className="mt-8 flex flex-col gap-3 max-w-md">
                        {[
                            { icon: Crosshair, t: "Auto-clip every key moment" },
                            { icon: Brain, t: "AI coach reviews every match" },
                            { icon: ShieldCheck, t: "Encounter & anomaly evidence" },
                        ].map((f) => (
                            <div key={f.t} className="flex items-center gap-3 text-sm text-foreground/80">
                                <span className="grid place-items-center w-8 h-8 rounded-sm bg-volt/10 border border-volt/30">
                                    <f.icon className="w-4 h-4 text-volt" />
                                </span>
                                {f.t}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="flex-1 flex items-center justify-center p-6 sm:p-10">
                <div className="w-full max-w-md ww-fade-up">
                    <div className="lg:hidden flex items-center gap-2.5 mb-8">
                        <div className="w-10 h-10 rounded-sm bg-black border border-white/10"
                            style={{ backgroundImage: `url(${LOGO_URL})`, backgroundSize: "175%", backgroundPosition: "center 32%", backgroundRepeat: "no-repeat" }} />
                        <span className="font-heading font-extrabold text-lg">WhiteWater<span className="text-volt">AI</span></span>
                    </div>
                    <h1 className="font-heading text-3xl font-black tracking-tighter text-white">{title}</h1>
                    {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
                    <div className="mt-8">{children}</div>
                </div>
            </div>
        </div>
    );
}
